import React from 'react';
import ReactDOM from 'react-dom';

const ROOT = document.getElementById('modal-root');

export default function Portal({ children }) {
  return <>{ReactDOM.createPortal(<>{children}</>, ROOT)}</>;
}
